import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import CONFIG from '@playcastdotio/GlobalConfig';
import { useAutoScaler } from '../../../hooks/useAutoScaler';
import '../../../styles/aida-base.css';
import '../../../styles/aida-responsive.css';
import { shouldForceLegalEmbedError } from './embedErrorDebug';
import { GoogleDocEmbed } from './GoogleDocEmbed';
import { LegalDocument, toEmbeddedUrl } from './legalDocuments';
import { LegalPageHeader } from './LegalPageHeader';
import { PURPLE_NEBULA } from './legalPageStyles';

type GoogleDocLegalPageProps = {
  document: LegalDocument;
};

export const GoogleDocLegalPage = ({ document }: GoogleDocLegalPageProps) => {
  const { isContentReady } = useAutoScaler();
  const [searchParams] = useSearchParams();
  const forceError = shouldForceLegalEmbedError(searchParams, CONFIG.ENVIRONMENT);

  return (
    <>
      <Helmet>
        <title>{document.helmetTitle}</title>
        <meta name='description' content={document.helmetDescription} />
      </Helmet>

      <div className='w-full' style={{ backgroundColor: 'black', margin: 0, padding: 0, width: '100%', overflow: 'hidden' }}>
        <div style={{ paddingTop: '60px', display: 'flex', justifyContent: 'center', margin: 0, padding: 0 }}>
          <div
            id='auto-scaler'
            style={{
              width: '1024px',
              transformOrigin: 'top center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: 0,
              padding: 0,
              overflow: 'visible',
              opacity: isContentReady ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
            }}
          >
            <div style={{ width: '100%', ...PURPLE_NEBULA, minHeight: '100vh' }}>
              <div className='px-4 pt-[72px] pb-16 lg:px-36 lg:pt-[120px] lg:pb-60' style={{ width: '100%' }}>
                <LegalPageHeader document={document} />
                <GoogleDocEmbed
                  src={toEmbeddedUrl(document.publishedUrl)}
                  title={document.iframeTitle}
                  publishedUrl={document.publishedUrl}
                  forceError={forceError}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
